import React from "react";

export const FeatureContext: any = React.createContext({
  configs: {},
  setConfigs: () => {},
});
